export enum SessionStorageKeyTypes {
  reviewPopupClosedByUser = 'reviewPopupClosedByUser',
  eventQueue = 'eventQueue',
  ibCreditStatus = 'ib_credit_{0}',
  isLoggedIn = 'isLoggedIn',
  userPromoShown = 'userPromoShown',
}

export enum SessionStorageValueTypes {
  closed = 'closed',
}
